/* eslint-disable import/prefer-default-export */
export enum PageType {
  notifications = 'Notifications',
  threadDetail = 'ThreadDetail',
  homepage = 'Homepage',
}
